<template>
  <component
    :is="linkComponentTag"
    v-bind="urlTag"
    class="base-link"
    :target="target"
    v-on="$listeners"
  >
    <slot />
    <BaseIcon
      v-if="showIcon"
      icon-file="chevron-right-blue"
      :width="12"
      :height="12"
      class="chevron-icon"
    />
  </component>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseLink',
  components: {
    BaseIcon
  },
  props: {
    link: {
      type: [String, Object],
      default: ''
    },
    isExternal: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    urlTag() {
      return this.isExternal ? { href: this.link } : { to: this.link };
    },
    linkComponentTag() {
      return this.isExternal ? 'a' : 'router-link';
    }
  }
};
</script>

<style lang="scss" scoped>
.base-link {
  display: inline-block;
  color: var(--Primary-Color);
  font-weight: 600;
  text-decoration: none;
  border-bottom: 2px solid var(--Primary-Color);
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:focus,
  &:hover {
    color: #2b8cee;
    border-color: #2b8cee;
  }

  &:visited {
    color: var(--Primary-Color);
  }
}

.chevron-icon {
  margin-top: 1px;
}
</style>
